var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFibrus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 129 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fibrus_svg__clip0_2020_87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.032 17.225H7.267c-1.123 0-1.768-.591-1.553-1.827l.267-1.503c.215-1.184 1.071-1.775 2.195-1.775h1.712l.534-3.063C11.438 3.09 16.63.187 21.289.187c1.071 0 2.142.16 3.05.375 1.231.324 1.713 1.451 1.286 2.795l-.641 1.99c-.43 1.344-1.179 1.827-2.517 1.56a12.511 12.511 0 00-1.497-.108c-1.82 0-2.784.967-3.106 2.794l-.482 2.527h4.07c1.178 0 1.666.437 1.414 1.895-.089.52-.282 1.605-.377 2.16-.178 1.023-1.52 1.05-2.75 1.05h-3.213L10.646 52.2c-.267 1.451-1.338 2.15-2.784 2.15H5.186c-1.445 0-2.25-.967-1.979-2.418l5.825-34.707z",
    fill: "url(#fibrus_svg__paint0_linear_2020_87)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.877 14.536c.267-1.504 1.39-2.42 2.84-2.42h2.675c1.446 0 2.25.916 1.98 2.42l-4.07 23.22c-.267 1.503-1.393 2.47-2.835 2.47H24.79c-1.446 0-2.25-1.02-1.98-2.47l4.066-23.22z",
    fill: "url(#fibrus_svg__paint1_linear_2020_87)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.903 3.089C29.17 1.582 30.296.67 31.742.67h2.676c1.445 0 2.25.912 1.98 2.419L36.01 5.26c-.267 1.504-1.393 2.471-2.838 2.471h-2.676c-1.446 0-2.25-1.02-1.98-2.47l.387-2.173z",
    fill: "url(#fibrus_svg__paint2_linear_2020_87)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.588 11.417c-2.516 0-4.496 1.076-5.837 2.367l.055-.493 1.787-10.202c.266-1.507-.535-2.419-1.98-2.419h-2.676c-.018 0-.037.003-.058.006L42.85.67c-.018.003-.034.01-.052.012-1.378.059-2.443.953-2.7 2.41l-3.861 22.03-.712 4.037c-1.286 7.416 3.802 11.773 9.528 11.773 7.228 0 12.153-4.354 13.44-11.773l1.07-5.913c1.394-7.956-3.155-11.829-7.976-11.829zm.43 12.097l-.964 5.374c-.641 3.71-2.624 5.537-4.87 5.537-2.302 0-3.747-1.828-3.106-5.537l1.393-7.848c1.124-1.612 3.158-3.118 4.819-3.118 2.246 0 3.425 1.506 2.728 5.592z",
    fill: "url(#fibrus_svg__paint3_linear_2020_87)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.136 22.275c1.124-6.504 5.515-10.858 12.313-10.858 1.07 0 2.035.108 2.624.216 1.445.268 2.142 1.236 1.712 2.742l-.534 1.883c-.426 1.504-1.338 2.043-2.516 1.827a8.806 8.806 0 00-1.713-.16c-2.357 0-3.962 1.827-4.391 4.354l-2.732 15.535c-.267 1.504-1.39 2.419-2.835 2.419h-2.676c-1.446 0-2.25-1.02-1.983-2.42l2.731-15.538z",
    fill: "url(#fibrus_svg__paint4_linear_2020_87)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.207 14.591c.267-1.56 1.393-2.471 2.835-2.471h2.676c1.446 0 2.247.967 1.983 2.471l-2.464 14.244c-.642 3.71.43 5.59 2.73 5.59 2.358 0 4.07-1.88 4.712-5.59l2.516-14.3c.267-1.503 1.393-2.418 2.839-2.418h2.676c1.445 0 2.249.967 1.979 2.47L102.173 29.1c-1.338 7.74-6.693 11.826-13.331 11.826-6.212 0-10.548-4.086-9.155-11.826l2.52-14.509z",
    fill: "url(#fibrus_svg__paint5_linear_2020_87)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.726 36.951l.537-1.611c.534-1.56 1.605-1.935 2.839-1.56.589.16 2.623.645 4.87.645 2.087 0 3.747-1.076 3.747-2.527 0-3.386-9.262-2.742-9.262-10.159 0-5.86 4.229-10.319 11.244-10.319 2.143 0 3.748.32 4.871.592 1.39.431 2.035 1.56 1.553 3.01l-.59 1.772c-.429 1.291-1.712 1.935-3.053 1.56-1.123-.269-2.142-.432-3.428-.432-2.142 0-2.891 1.127-2.891 2.258 0 3.331 9.21 3.063 9.21 10.59 0 5.054-3.48 10.159-11.993 10.159-3.054 0-5.356-.7-6.264-.968-1.283-.43-1.872-1.558-1.39-3.01z",
    fill: "url(#fibrus_svg__paint6_linear_2020_87)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.673 53.605c-.098.496.098.743.593.743h3.025c.835 0 1.599-.154 2.287-.46a5.46 5.46 0 001.783-1.25 5.623 5.623 0 001.157-1.85 6.276 6.276 0 00.411-2.276c0-.604-.101-1.14-.301-1.615a3.228 3.228 0 00-.884-1.201 3.884 3.884 0 00-1.399-.75c-.546-.172-1.172-.255-1.872-.255h-2.342c-.494 0-.788.247-.886.743l-1.572 8.171zm2.6-1.285l1.089-5.605h.967c.672 0 1.206.17 1.596.506.389.339.586.841.586 1.507 0 .496-.077.96-.227 1.398a3.494 3.494 0 01-.654 1.14c-.282.324-.626.58-1.028.77a3.099 3.099 0 01-1.344.284h-.985zm-14.492 1.285c-.098.496.098.743.593.743h.874c.494 0 .789-.25.887-.743l.727-3.756a7.65 7.65 0 00.074-.514c.022-.188.043-.37.061-.54.028-.197.05-.394.068-.594h.025c.046.188.095.382.147.582.046.172.095.351.153.545.059.194.123.367.194.521l1.602 4c.125.332.386.499.779.499h1.05c.494 0 .788-.25.887-.743l1.574-8.174c.098-.496-.098-.743-.592-.743h-.875c-.494 0-.789.247-.887.743l-.727 3.768a4.817 4.817 0 00-.089.511l-.062.543c-.027.197-.049.394-.067.591h-.028a33.741 33.741 0 00-.147-.579 12.709 12.709 0 00-.154-.54 8.084 8.084 0 00-.181-.526l-1.589-4.012c-.126-.332-.39-.499-.792-.499h-1.05c-.494 0-.788.247-.886.743l-1.569 8.174zm-7.522-3.177l.915-1.876.236-.515c.086-.188.163-.37.233-.539l.243-.607h.028c0 .207.006.41.012.607.009.173.015.351.021.54.006.187.016.36.034.514l.175 1.876h-1.897zm-3.915 3.07c-.136.261-.163.468-.08.619.08.154.254.23.525.23h.942c.43 0 .745-.209.942-.622l.672-1.405h3.001l.135 1.405c.056.413.292.623.712.623h.887c.267 0 .476-.077.62-.231.141-.151.19-.361.147-.62l-1.197-8.199c-.055-.407-.291-.607-.712-.607h-1.411c-.43 0-.749.203-.955.607l-4.228 8.2zM79.27 52.32l.39-2h1.426c.286 0 .5.071.639.216a.75.75 0 01.209.54c0 .224-.059.434-.175.634a1.277 1.277 0 01-.418.447 1.303 1.303 0 01-.66.163H79.27zm.752-3.888l.334-1.717h1.172c.267 0 .46.062.571.182.11.12.169.278.169.466 0 .126-.022.255-.068.385a.948.948 0 01-.202.345c-.092.098-.2.178-.332.243a1.01 1.01 0 01-.438.096h-1.206zm-3.352 5.173c-.098.496.099.743.593.743h3.2c.261 0 .522-.016.78-.05s.51-.089.752-.17c.322-.107.626-.249.914-.424.289-.176.537-.386.752-.635.215-.247.384-.53.504-.844.122-.315.18-.663.18-1.042a2.53 2.53 0 00-.254-1.134c-.172-.342-.47-.594-.902-.755v-.027a2.606 2.606 0 001.101-.986c.261-.422.39-.87.39-1.337 0-.46-.132-.87-.396-1.236-.264-.364-.641-.632-1.123-.804a3.412 3.412 0 00-.78-.17 8.46 8.46 0 00-.902-.046h-2.354c-.494 0-.788.247-.886.743l-1.569 8.174zm-11.665 0c-.098.496.099.743.593.743h3.026c.834 0 1.596-.154 2.286-.46a5.457 5.457 0 001.783-1.25 5.623 5.623 0 001.157-1.85 6.274 6.274 0 00.411-2.276c0-.604-.101-1.14-.304-1.615a3.23 3.23 0 00-.88-1.201 3.888 3.888 0 00-1.4-.75c-.546-.172-1.172-.255-1.872-.255h-2.341c-.495 0-.79.247-.887.743l-1.572 8.171zm2.6-1.285l1.09-5.605h.969c.672 0 1.206.17 1.596.506.39.339.586.841.586 1.507 0 .496-.077.96-.227 1.398a3.48 3.48 0 01-.654 1.14c-.282.324-.626.58-1.028.77a3.1 3.1 0 01-1.344.284h-.988zm-10.118-1.892l.914-1.876.236-.515c.086-.188.163-.37.234-.539l.242-.607h.028c0 .207.006.41.012.607.01.173.015.351.022.54.006.187.015.36.033.514l.175 1.876h-1.896zm-3.916 3.07c-.135.261-.163.468-.08.619.08.154.255.23.525.23h.942c.43 0 .746-.209.942-.622l.672-1.405h3.001l.136 1.405c.055.413.291.623.711.623h.887c.27 0 .476-.077.62-.231.145-.151.19-.361.148-.62l-1.197-8.199c-.052-.407-.292-.607-.712-.607H58.75c-.43 0-.749.203-.954.607l-4.226 8.2zm-5.153-6.656c.26.105.485.252.672.447.187.194.335.425.439.696.104.268.153.57.153.903 0 .487-.092.943-.273 1.365a3.686 3.686 0 01-.727 1.1c-.3.308-.642.551-1.022.73-.38.176-.77.262-1.163.262-.313 0-.602-.056-.862-.163a1.871 1.871 0 01-.673-.466 2.176 2.176 0 01-.438-.724 2.629 2.629 0 01-.154-.93c0-.469.09-.91.267-1.325a3.46 3.46 0 011.743-1.79c.38-.176.774-.265 1.179-.265.31.006.598.058.859.16zm-.525 7.456a5.664 5.664 0 001.332-.594c.42-.256.807-.561 1.157-.912.35-.352.654-.74.915-1.168.26-.428.46-.884.604-1.371.144-.487.215-.99.215-1.513 0-.613-.107-1.177-.322-1.689a3.867 3.867 0 00-.918-1.33 4.229 4.229 0 00-1.433-.879 5.22 5.22 0 00-1.863-.317c-.733 0-1.442.15-2.123.453a5.941 5.941 0 00-3.051 3.04 5.291 5.291 0 00-.463 2.182c0 .623.104 1.196.316 1.723.212.527.512.98.908 1.365.393.382.869.684 1.424.896a5.132 5.132 0 001.872.327c.488 0 .964-.07 1.43-.213zm-13.402-5.232l.458-2.35h1.061c.304 0 .547.07.722.215.175.145.264.36.264.65 0 .487-.145.857-.43 1.106-.289.253-.642.38-1.062.38h-1.013zm-3.228 4.54c-.098.495.098.742.592.742h.875c.494 0 .789-.25.887-.743l.485-2.514h1.209l.902 2.73c.117.351.371.527.767.527h.918c.285 0 .497-.084.632-.25.135-.166.15-.382.052-.644l-.899-2.486c-.037-.09-.07-.17-.101-.235a1.71 1.71 0 00-.086-.17 1.082 1.082 0 01-.083-.135v-.027c.368-.145.681-.342.936-.595.255-.253.46-.53.62-.829.156-.302.27-.613.344-.933.07-.32.107-.623.107-.912 0-.54-.126-.999-.378-1.378a2.214 2.214 0 00-1.061-.838 3.147 3.147 0 00-.666-.175 4.847 4.847 0 00-.746-.056H33.73c-.494 0-.788.246-.89.743l-1.577 8.177zm-7.909-1.286l.39-2h1.427c.289 0 .5.071.638.216a.75.75 0 01.21.54c0 .224-.06.434-.176.634-.116.2-.255.345-.417.447a1.303 1.303 0 01-.66.163h-1.412zm.752-3.888l.338-1.717h1.169c.267 0 .46.062.57.182.111.123.17.278.17.466 0 .126-.022.255-.068.385a.948.948 0 01-.203.345c-.088.098-.199.178-.33.243a1 1 0 01-.44.096h-1.206zm-3.351 5.173c-.098.496.098.743.592.743h3.201c.26 0 .522-.016.78-.05.257-.034.509-.089.752-.17.322-.107.626-.249.914-.424.288-.176.537-.386.752-.635a2.788 2.788 0 00.684-1.886 2.53 2.53 0 00-.255-1.134c-.171-.342-.469-.594-.902-.755v-.027a2.605 2.605 0 001.102-.986c.26-.422.39-.87.39-1.337 0-.46-.132-.87-.4-1.236-.263-.364-.637-.632-1.122-.804a3.413 3.413 0 00-.78-.17 8.443 8.443 0 00-.9-.046H23.21c-.494 0-.789.247-.89.743l-1.565 8.174z",
    fill: "url(#fibrus_svg__paint7_linear_2020_87)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fibrus_svg__paint0_linear_2020_87",
    x1: 4.756,
    y1: 27.088,
    x2: 124.651,
    y2: 29.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52B049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#52B049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#0092BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0092BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fibrus_svg__paint1_linear_2020_87",
    x1: 4.786,
    y1: 25.674,
    x2: 124.681,
    y2: 28.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52B049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#52B049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#0092BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0092BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fibrus_svg__paint2_linear_2020_87",
    x1: 5.245,
    y1: 3.63,
    x2: 125.14,
    y2: 6.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52B049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#52B049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#0092BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0092BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fibrus_svg__paint3_linear_2020_87",
    x1: 4.905,
    y1: 19.951,
    x2: 124.8,
    y2: 22.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52B049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#52B049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#0092BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0092BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fibrus_svg__paint4_linear_2020_87",
    x1: 4.81,
    y1: 24.477,
    x2: 124.705,
    y2: 26.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52B049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#52B049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#0092BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0092BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fibrus_svg__paint5_linear_2020_87",
    x1: 4.808,
    y1: 24.614,
    x2: 124.703,
    y2: 27.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52B049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#52B049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#0092BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0092BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fibrus_svg__paint6_linear_2020_87",
    x1: 4.823,
    y1: 23.869,
    x2: 124.718,
    y2: 26.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52B049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#52B049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#0092BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0092BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fibrus_svg__paint7_linear_2020_87",
    x1: 4.317,
    y1: 48.182,
    x2: 124.212,
    y2: 50.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52B049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#52B049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#0092BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0092BE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fibrus_svg__clip0_2020_87"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3)",
    d: "M0 0h122v55H0z"
  })))));
}
export default SvgFibrus;